import useCurrentTime from '$tablet-app/src/app/utils/useCurrentTime';
import { useMemo } from 'react';
import {
  createStickyNote,
  getAvatarStickyNote,
  getAvatarStickyNoteTimePeriod,
} from '../functions';

const useAvatarStickyNote = () => {
  /** Use the current time hook to ensure the time is recomputed */
  const current_time = useCurrentTime();

  /** Get the time of day based on the current time */
  const time_of_day = getAvatarStickyNoteTimePeriod(new Date(current_time));

  /** Only recompute the sticky not whenever the "time_of_day" changes */
  return useMemo(
    () =>
      createStickyNote({
        content: getAvatarStickyNote(time_of_day),
        ai_generated: true,
        owner: { id: '', habitatID: '', location: '', name: 'Pixi' }, // Spoof the owner to easily display the pixi name
      }),
    [time_of_day]
  );
};

export default useAvatarStickyNote;
